import { css, cx } from '@eti/styles';
import { getUniqueMarketingCarriersFromSegments } from '../../../../utils/carriers';
import type { BoundsType } from '../../../../common/types/transformations/models';
import {
  boundIncludesTrainSegments,
  getBoundAsSegment,
  getBoundType,
} from '../../../trip-details/utils/format';
import CartTripBoundInfo from './CartTripBoundInfo';

const wrapperStyles = css`
  margin-bottom: 18px;
  width: 100%;
`;

const boundStyles = css`
  position: relative;
  width: 100%;

  &:not(:last-child) {
    margin-bottom: 24px;
  }
`;

interface CartTripInfoProps {
  bounds: BoundsType;
  className?: string;
  dataTestId?: string;
  isMultiStop: boolean;
}

const CartTripInfo = ({ bounds, className, dataTestId, isMultiStop }: CartTripInfoProps) => {
  const getNumberOfTechincalStopsFromBound = (bound: BoundsType[number]) => {
    return (
      bound.segments
        ?.filter((segment) => segment.__typename === 'TripSegment')
        .reduce((acc, segment) => {
          if (Number.isFinite(segment.numberOfTechnicalStops)) {
            return acc + segment.numberOfTechnicalStops;
          }

          return acc;
        }, 0) ?? 0
    );
  };

  return (
    <div className={cx(wrapperStyles, className)} data-testid={dataTestId}>
      {bounds?.map((bound, index) => (
        <div
          className={boundStyles}
          data-testid={`cartTrip-bound-${bound.boundId}`}
          key={`boundInfo-${bound.boundId}`}
        >
          <CartTripBoundInfo
            boundId={bound.boundId}
            includesTrainSegments={boundIncludesTrainSegments(bound.segments)}
            isMultiStop={isMultiStop}
            marketingCarriers={getUniqueMarketingCarriersFromSegments(bound.segments)}
            numberOfTechnicalStops={getNumberOfTechincalStopsFromBound(bound)}
            segment={getBoundAsSegment(bound.segments, index + 1)}
            type={getBoundType(index)}
          />
        </div>
      ))}
    </div>
  );
};

export default CartTripInfo;
